




























import { Vue, Component, Prop, Emit } from "vue-property-decorator"

@Component
export default class DatePicker extends Vue {
  get innerDate(): string {
    return this.date
  }
  set innerDate(value: string) {
    if (this.label === "公開日") {
      this.emitPublishDate(value, this.label)
    } else if (this.label === "公開終了予定日") {
      this.emitEndOfPublishDate(value, this.label)
    } else if (this.label === "RSS公開日") {
      this.emitRssPublishDate(value, this.label)
    } else {
      this.emitPublishDate(value, this.label) // default
    }
  }

  private enable = false

  @Prop()
  private label!: string

  @Prop({ default: "" })
  private date!: string

  @Prop()
  private disabled!: boolean

  @Emit("emitPublishDate")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public emitPublishDate(date: string, label: string): void {
    this.enable = false
  }

  @Emit("emitEndOfPublishDate")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public emitEndOfPublishDate(date: string, label: string): void {
    this.enable = false
  }

  @Emit("emitRssPublishDate")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public emitRssPublishDate(date: string, label: string): void {
    this.enable = false
  }

  private clearable() {
    this.emitPublishDate("", this.label)
  }
}
